// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zqe9ScsGf1prNH {
  padding: 12px;
  border-radius: 8px;
  background: var(--ds-background-neutral, #091e420f);
}
.Zqe9ScsGf1prNH.Y5397IneF_cLlQ {
  background: var(--ds-background-discovery, #f3f0ff);
}
.Zqe9ScsGf1prNH h3 {
  margin-bottom: 4px;
  font-size: 14px;
}
.Zqe9ScsGf1prNH button {
  margin: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Zqe9ScsGf1prNH`,
	"canUpgrade": `Y5397IneF_cLlQ`
};
export default ___CSS_LOADER_EXPORT___;
